__turbopack_context__.v({
  "band": "subpage-module__I0rA3G__band",
  "bandBody": "subpage-module__I0rA3G__bandBody",
  "bandCopy": "subpage-module__I0rA3G__bandCopy",
  "bandForm": "subpage-module__I0rA3G__bandForm",
  "bandHeadline": "subpage-module__I0rA3G__bandHeadline",
  "bandRow": "subpage-module__I0rA3G__bandRow",
  "cta": "subpage-module__I0rA3G__cta",
  "eyebrow": "subpage-module__I0rA3G__eyebrow",
  "footer": "subpage-module__I0rA3G__footer",
  "footerBrand": "subpage-module__I0rA3G__footerBrand",
  "footerCopy": "subpage-module__I0rA3G__footerCopy",
  "footerDetails": "subpage-module__I0rA3G__footerDetails",
  "footerLink": "subpage-module__I0rA3G__footerLink",
  "footerLoc": "subpage-module__I0rA3G__footerLoc",
  "footerLockup": "subpage-module__I0rA3G__footerLockup",
  "footerMark": "subpage-module__I0rA3G__footerMark",
  "footerX": "subpage-module__I0rA3G__footerX",
  "header": "subpage-module__I0rA3G__header",
  "headerActions": "subpage-module__I0rA3G__headerActions",
  "headerInner": "subpage-module__I0rA3G__headerInner",
  "headerSide": "subpage-module__I0rA3G__headerSide",
  "headline": "subpage-module__I0rA3G__headline",
  "hero": "subpage-module__I0rA3G__hero",
  "label": "subpage-module__I0rA3G__label",
  "locale": "subpage-module__I0rA3G__locale",
  "logo": "subpage-module__I0rA3G__logo",
  "logoMark": "subpage-module__I0rA3G__logoMark",
  "main": "subpage-module__I0rA3G__main",
  "menuToggle": "subpage-module__I0rA3G__menuToggle",
  "menuToggleBars": "subpage-module__I0rA3G__menuToggleBars",
  "menuToggleLabel": "subpage-module__I0rA3G__menuToggleLabel",
  "nav": "subpage-module__I0rA3G__nav",
  "navLink": "subpage-module__I0rA3G__navLink",
  "navLinkCurrent": "subpage-module__I0rA3G__navLinkCurrent",
  "navList": "subpage-module__I0rA3G__navList",
  "navOpen": "subpage-module__I0rA3G__navOpen",
  "navX": "subpage-module__I0rA3G__navX",
  "pageEnd": "subpage-module__I0rA3G__pageEnd",
  "root": "subpage-module__I0rA3G__root",
  "subhead": "subpage-module__I0rA3G__subhead",
});
